import * as React from 'react';
import { translate } from 'react-i18next';
import { IProductListItemCard } from 'models/product/productlistitem';
import * as c from 'models/constants';
import { ItemCardButtons } from 'components';
import { IItemCardProps, IItemCardButtonsProps } from 'models/itemcard';
// import { ProductCardItemMenu } from 'components/ContextMenus';
import { formatCurrency, setProductPictureUrl } from 'helpers/common';
import { NodeType } from 'models/enums/nodetype/nodetype';
import { IAuthContext, INodeData } from 'models/common';
import { withAuthContext } from 'containers/AccessControl/WithAuthContext';
interface IProps extends IItemCardProps {
	item: IProductListItemCard;
	unwishItem?: (itemType: NodeType, itemId: string) => void;
	wishlistItem?: (itemType: NodeType, itemId: string) => void;
	t?: (key: string, options?: any) => string;
	context?: IAuthContext;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ProductItemCardComponent extends React.Component<IProps, any> {
	private showProductCardItemDropdownMenu: boolean = false;
	private productCardItemDropdownButtonElement: HTMLElement;

	constructor(props) {
		super(props);

		this.editItem = this.editItem.bind(this);
		this.deleteItem = this.deleteItem.bind(this);
		this.likeItem = this.likeItem.bind(this);
		this.unlikeItem = this.unlikeItem.bind(this);
		this.selectItem = this.selectItem.bind(this);
		this.handleWishlist = this.handleWishlist.bind(this);
		this.handleUnwish = this.handleUnwish.bind(this);
		this.goToCard = this.goToCard.bind(this);

		this.handleShowProductCardItemContextMenuClicked = this.handleShowProductCardItemContextMenuClicked.bind(this);
		this.handleProductCardItemContextMenuClickedOutsite =
			this.handleProductCardItemContextMenuClickedOutsite.bind(this);
	}

	private handleShowProductCardItemContextMenuClicked() {
		this.showProductCardItemDropdownMenu = !this.showProductCardItemDropdownMenu;
		this.forceUpdate();
	}

	private handleProductCardItemContextMenuClickedOutsite(e: any) {
		if (!this.productCardItemDropdownButtonElement.contains(e.target)) {
			if (this.showProductCardItemDropdownMenu) {
				this.showProductCardItemDropdownMenu = false;
				this.forceUpdate();
			}
		}
	}

	public editItem() {
		if (this.props.editItem !== undefined) {
			this.props.editItem(this.props.item.id);
		}
	}

	public deleteItem(e: any) {
		e.cancelBubble = true;
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		if (this.props.deleteItem !== undefined) {
			this.props.deleteItem('', this.props.item.id);
		}
	}

	private likeItem() {
		if (this.props.likeItem) {
			this.props.likeItem(NodeType.Product, this.props.item.id);
		}
	}

	private unlikeItem() {
		if (this.props.unlikeItem) {
			this.props.unlikeItem(NodeType.Product, this.props.item.id);
		}
	}

	private handleWishlist() {
		if (this.props.wishlistItem) {
			this.props.wishlistItem(NodeType.Product, this.props.item.id);
			this.showProductCardItemDropdownMenu = !this.showProductCardItemDropdownMenu;
			this.forceUpdate();
		}
	}

	private handleUnwish() {
		if (this.props.unwishItem) {
			this.props.unwishItem(NodeType.Product, this.props.item.id);
			this.showProductCardItemDropdownMenu = !this.showProductCardItemDropdownMenu;
			this.forceUpdate();
		}
	}

	private selectItem() {
		if (!this.props.item.isSelected) {
			this.props.selectItemObject(this.props.item);
		}
	}

	private goToCard(e: any, id, type) {
		e.preventDefault();
		e.stopPropagation();
		if (this.props.goToCard) {
			this.props.goToCard(id, type);
		}
	}

	private renderSelectButton(isSelected: boolean = false) {
		let selectBtn: JSX.Element = null;
		if (this.props.selectItemObject && (isSelected !== undefined || isSelected !== null)) {
			selectBtn = (
				<div className="checkboxPosition">
					<label className="container">
						<span className="checkmark" onClick={this.selectItem} />
					</label>
				</div>
			);
		}
		return selectBtn;
	}

	public render() {
		const { isMyItem } = this.props;
		const { picture, name, price, originalPrice, addedBy, shopId, isSelected, entityId, shopCurrencyKey } =
			this.props.item;

		const entityIdObj: INodeData = JSON.parse(entityId);

		const itemCardButtonsProps: IItemCardButtonsProps = {
			editItem: this.props.editItem && isMyItem ? this.editItem : null,
			deleteItem: this.props.deleteItem && isMyItem ? this.deleteItem : null,
		};

		return (
			<div className="commonItemCard">
				{this.renderSelectButton(isSelected)}
				<a
					href="#"
					className="d-block"
					onClick={(e) => {
						this.goToCard(e, entityIdObj.id, c.NODE_TYPE_PRODUCT);
					}}
				>
					<figure className="image">
						<img {...setProductPictureUrl(picture, true)} />
						<figcaption>
							<h3>{name}</h3>
							<div className="prices">
								<strong>{formatCurrency(shopCurrencyKey, price)}</strong>
								{originalPrice > price ? (
									<strong className="sale">{formatCurrency(shopCurrencyKey, originalPrice)}</strong>
								) : null}
							</div>
						</figcaption>
						{!this.props.disableActions ? <ItemCardButtons {...itemCardButtonsProps} /> : null}
					</figure>
					<div className="below">
						<span
							onClick={(e) => {
								this.goToCard(e, shopId, c.NODE_TYPE_SHOP);
							}}
						>
							{addedBy}
						</span>
					</div>
				</a>
			</div>
		);
	}
}
const ProductItemCard = withAuthContext(ProductItemCardComponent);
export { ProductItemCard };
